import moment from "moment"
import React, { useState } from "react"
import { CardBody, Col, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import PhoneImageIcon from '../../../assets/images/icon-phone.png';
import IconEdit from '../../../assets/images/icon-edit.png';
import Select from 'react-select';
import IconCalendar from '../../../assets/images/icon/ic_calendar-black.svg';
import { ExaminationForm, ExaminationType } from "../../../constants/nutriconstant"
import CalcUtils from "../../../helpers/CalcUltils"
import { isEmpty } from "lodash"
import { toast } from "react-toastify"
import ModalPopup from "../../../components/ModalPopup"
import CustomerAdd from "../../customer/CustomerAdd"
import { useHistory } from "react-router"
import NumberFormat from "react-number-format"
import TextUtils from "../../../helpers/TextUtils"
import ToggleButton from "../../../common/ToggleButton"
import { ValueText } from "../ProductAdd"
import { ProductType } from "../ProductList"
import IconCheckbox from '../../assets/images/icon-checkbox.png';
import IconCheckboxActive from '../../assets/images/icon-checkbox-active.png';

const ProductExpiration = (props: any) => {
    const { data, setData, type, onlyView, handleChangeInput, category, brand, origin, validation } = props

    return (
        <PageBody>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div className="nutri-title mb-3">Cảnh báo hết hạn</div>
                <ToggleButton isDisabled={type == 'view' ? true: false} elmChecked={data?.expiration_status == 1 ? true : false} data={data} setData={(data:any) => {setData(data)}} name='expiration_status' />
            </div>
            {data?.expiration_status == 1 &&
            <Row>
                <Col md={6} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Ngày đến hạn</Label>
                        <InputGroup>
                            <NumberFormat 
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeInput({target:{ name: "expiration_day_number" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                name={'expiration_day_number'} type={'text'} className="form-control" 
                                value={type === 'view' && !data?.expiration_day_number ? '---': data?.expiration_day_number}
                                placeholder={(type=='view' && !data?.expiration_day_number) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                            />
                            {validation?.expiration_day_number &&<div className="invalid-feedback d-block" >{validation?.expiration_day_number}</div>}
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Ngày cảnh báo</Label>
                        <InputGroup>
                            <NumberFormat 
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeInput({target:{ name: "warning_day_number" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                name={'warning_day_number'} type={'text'} className="form-control" 
                                value={type === 'view' && !data?.warning_day_number ? '---': data?.warning_day_number}
                                placeholder={(type=='view' && !data?.warning_day_number) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                            />
                            {validation?.warning_day_number &&<div className="invalid-feedback d-block" >{validation?.warning_day_number}</div>}
                        </InputGroup>
                    </FormGroup>
                </Col>
            </Row>}
        </PageBody>
    )
}

export default ProductExpiration